export const Posts = {
  text: 'Posts',
  link: '/posts',
  icon: 'icon-speech'
};

export const Treinamentos = {
  text: 'Treinamentos',
  link: '/treinamentos',
  icon: 'icon-graduation'
};

export const Banners = {
  text: 'Banners',
  link: '/banners',
  icon: 'icon-picture'
};

export const Inconsistencias = {
  text: 'Inconsistências',
  icon: 'icon-wrench',
  submenu: [
    {
      text: 'Resumo',
      link: '/inconsistencias/resumo'
    }
  ]
};

// MENU USUARIOS //

export const menu = [
  /*{
    text: 'Dashboard',
    icon: 'icon-chart',
    submenu: [
      {
        text: 'Vendas',
        link: '/dashboard/vendas'
      }
    ]
  },*/
  /*{
    text: 'Rankings',
    icon: 'icon-badge',
    submenu: [
      {
        text: 'PDV',
        link: '/ranking/pdv'
      }
    ]
  },*/
  {
    text: 'Usuários',
    link: '/usuarios',
    icon: 'icon-home'
  },
  /*{
    text: 'PDVs',
    link: '/pdvs',
    icon: 'icon-people'
  },*/
  /*{
    text: 'Ativações',
    link: '/ativacoes',
    icon: 'icon-screen-smartphone'
  },*/
 /* {
    text: 'Carteira do CN',
    icon: 'icon-wallet',
    submenu: [
      /*{
        text: 'Dashboard',
        link: '/carteira-cn/dashboard'
      },
      {
        text: 'Ações',
        link: '/carteira-cn/acoes'
      },
      {
        text: 'Extrato',
        link: '/carteira-cn/extrato'
      },
      {
        text: 'PIX',
        link: '/carteira-cn/transferencia'
      }
    ]
  }*/
];

export const menuBackoffice = [
  /*{
    text: 'Dashboard',
    icon: 'icon-chart',
    submenu: [
      {
        text: 'Vendas',
        link: '/dashboard/vendas'
      }
    ]
  },*/
  {
    text: 'Usuários',
    link: '/usuarios',
    icon: 'icon-home'
  },
  /*{
    text: 'PDVs',
    icon: 'icon-people',
    submenu: [
      {
        text: 'PDVs',
        link: '/pdvs',
      },
      {
        text: 'Acompanhamento',
        link: '/pdvs-admin',
      }
    ]
  },*//*
  {
    text: 'Ativações',
    link: '/ativacoes',
    icon: 'icon-screen-smartphone'
  },*/
  Banners
];

// MENU CN
export const menuCN = [
 /* {
    text: 'Dashboard',
    icon: 'icon-chart',
    submenu: [
      {
        text: 'Vendas',
        link: '/dashboard/vendas'
      }
    ]
  },*/
  {
    text: 'Usuários',
    icon: 'icon-people',
    submenu: [
      {
        text: 'Novo Usuário',
        link: '/usuarios/novo'
      }
    ]
  },
  /*{
    text: 'PDVs',
    icon: 'icon-home',
    submenu: [
      {
        text: 'PDVs',
        link: '/pdvs',
      },
      {
        text: 'Acompanhamento',
        link: '/pdvs-admin',
      }
    ]
  },*/
 /* {
    text: 'Ativações',
    link: '/ativacoes',
    icon: 'icon-screen-smartphone'
  },
  {
    text: 'Carteira Chipcoins',
    icon: 'icon-wallet',
    submenu: [
      {
        text: 'Extrato',
        link: '/carteira-cn/extrato'
      },
      {
        text: 'PIX',
        link: '/carteira-cn/transferencia'
      }
    ]
  }*/
];

// MENU SUPERVISOR
export const menuSupervisor = [
/*  {
    text: 'Dashboard',
    icon: 'icon-chart',
    submenu: [
      {
        text: 'Vendas',
        link: '/dashboard/vendas'
      },
      {
        text: 'Pontos',
        link: '/dashboard/pontos-supervisor'
      }
    ]
  },*/
  {
    text: 'Usuários',
    link: '/usuarios',
    icon: 'icon-home'
  },
  /*{
    text: 'PDVs',
    link: '/pdvs-admin',
    icon: 'icon-home'
  },
  {
    text: 'Ativações',
    link: '/ativacoes',
    icon: 'icon-screen-smartphone'
  }*/
];

// MENU ICONS
export const menuIcons = [
 {
    text: 'Dashboard',
    icon: 'icon-chart',
    submenu: [
      {
        text: 'Resultados',
        link: '/dashboard/resultados'
      },
      {
        text: 'PDVs',
        link: '/dashboard/pdvs'
      },
      {
        text: 'Vendas',
        link: '/dashboard/vendas'
      },
      {
        text: 'Pontos',
        link: '/dashboard/pontos'
      }
    ]
  },
  {
    text: 'Sonar',
    icon: 'icon-feed',
    submenu: [
      {
        text: 'Dashboard',
        link: '/dashboard/sonar'
      },
      {
        text: 'Logins',
        link: '/sonar/logins'
      },
      {
        text: 'Liberação de Resgates',
        link: '/sonar/resgates'
      }
    ]
  },
  /*{
text: 'Rankings',
icon: 'icon-badge',
submenu: [
  /*
  {
    text: 'Lojas',
    link: '/ranking/lojas'
  },
  {
    text: 'Redes',
    link: '/ranking/redes'
  },
  {
    text: 'DDDs',
    link: '/ranking/ddds'
  },
  {
    text: 'CNs',
    link: '/ranking/cns'
  },

  {
    text: 'PDV',
    link: '/ranking/pdv'
  }
]
  },*/
  {
  text: 'Usuários',
  icon: 'icon-people',
  submenu: [
    {
      text: 'Novo Usuário',
      link: '/usuarios/novo'
    },
    {
      text: 'Todos os Usuários',
      link: '/usuarios'
    }
  ]
  },
  /*{
  text: 'PDVs',
  icon: 'icon-home',
  link: '/pdvs-admin'
  },
  {
    text: 'Ativações',
    link: '/ativacoes',
    icon: 'icon-screen-smartphone'
  },
  {
    text: 'Carteira Chipcoins',
    icon: 'icon-wallet',
    submenu: [
      // {
      //   text: 'Dashboard',
      //   link: '/carteira-cn/dashboard'
      // },
      // {
      //   text: 'Ações',
      //   link: '/carteira-cn/acoes'
      // },
      {
        text: 'Extrato',
        link: '/carteira-cn/extrato'
      },
      {
        text: 'PIX',
        link: '/carteira-cn/transferencia'
      }
    ]
  }*/,
  {
    text: 'Posts',
    link: '/posts',
    icon: 'icon-speech'
  },
  Banners,
 /* {
    text: 'Pop-ups',
    link: '/popups',
    icon: 'far fa-comment'
  },
  */{
    text: 'Chamados',
    icon: 'icon-bubbles',
    submenu: [
      {
        text: 'Chamados',
        link: '/chamados'
      },
      {
        text: 'Satisfação',
        link: '/chamados/satisfacao'
      }
    ]
  },
  {
    text: 'CloudLoyalty',
    icon: 'icon-basket',
    submenu: [
      {
        text: 'Usuários',
        link: '/cloudloyalty/usuarios'
      },
      {
        text: 'Resgates',
        link: '/cloudloyalty/resgates'
      }
    ],
  },
  /*{
    text: 'Apuração',
    icon: 'icon-calculator',
    submenu: [
      {
        text: 'Upload',
        link: '/apuracao/upload'
      },
      {
        text: 'Liberar',
        link: '/apuracao/liberar'
      }
    ],
  },*/
  /*{
    text: 'Configurações',
    icon: 'fas fa-cog',
    submenu: [
      {
        text: 'Metas',
        link: '/configuracao/metas'
      },
      // {
      //   text: 'Inserir nova meta',
      //   link: '/configuracao/inserir'
      // },
    ]
  },*/
 /* {
    text: 'Push Notification',
    icon: 'icon-bell',
    submenu: [
      {
        text: 'Push',
        link: '/push-notification'
      }
    ]
  }*/
];
